module.exports = __webpack_public_path__ + "static/media/image2.be25a283.jpg";